import { useState, useRef } from "react";
import { useSelector } from "react-redux";

import Draggable from "react-draggable";

function CardPreview(props) {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;
  const currentPreviewState = useSelector((state) => state.cardPreview);
  const showCardSignature =
    !requestDetails.DoNotSignCard ||
    requestDetails.CardTypeValue !== "sendtome";
  const isSendToMe = requestDetails.CardTypeValue === "sendtome";
  const isEcard = requestDetails.CardTypeValue === "ecard";
  const showReturnAddress =
    !isSendToMe &&
    requestDetails.UseAddress !== "none" &&
    requestDetails.UseAddress !== "billing";

  let previewHeight = { height: "auto" };
  if (props.preview) {
    if (props.approve) {
      previewHeight = { height: "102vw" };
    } else {
      previewHeight = { height: "72vw" };
    }
  }

  return (
    <div className="cfg-preview-card-container" style={previewHeight}>
      {props.preview && <p>Tip: Pinch and zoom your screen to explore details more closely!</p>}
      <div
        className="cfg-preview-card"
        style={{ transform: `scale(${props.zoom})` }}
      >
        <Draggable>
          <div
            className="cfg-draggable-area"
            style={{ cursor: props.preview ? "default" : "grab" }}
          >
            {props.showCard && (
              <div className="cfg-card-contain">
                <div className="cfg-card inside">
                  <img
                    className="bg-inside-img"
                    src={currentPreviewState.SelectedCard.InsideImage}
                  />
                  <div className="inside-verse"></div>
                  <div
                    className="inside-text-contain"
                    style={{ paddingTop: "100px" }}
                  >
                    <div
                      className={`intention parse-new-lines ${
                        currentPreviewState.FocusedField === "intention"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ marginTop: "18px", height: "40px" }}
                    >
                      {currentPreviewState.CardIntention}
                    </div>

                    <div
                      className={`sign-as-lines parse-new-lines ${
                        currentPreviewState.FocusedField === "cardSignature"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ marginTop: "378px" }}
                    >
                      {showCardSignature && (
                        <div>{currentPreviewState.CardSignature}</div>
                      )}
                      {!showCardSignature && (
                        <div>
                          <p className="signline">&nbsp;</p>
                          <p className="signline">&nbsp;</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card front">
                  <img
                    className="cover-img"
                    src={currentPreviewState.SelectedCard.CoverImage}
                  />
                </div>
              </div>
            )}

            {props.showEnvelope && !isEcard && (
              <div className="envelope-contain" style={{ marginTop: "72px" }}>
                <div className="envelope-content">
                  <img
                    className="envelope-img"
                    src={
                      currentPreviewState.SelectedCard.EnvelopeBackgroundImage
                    }
                  />

                  {showReturnAddress && (
                    <div
                      className={`envelope-return-addr parse-new-lines ${
                        currentPreviewState.FocusedField === "envelope-return"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ top: "18.0000px", left: "18.0000px" }}
                    >
                      {currentPreviewState.EnvelopeReturnAddress}
                    </div>
                  )}

                  {!isSendToMe && requestDetails.UseAddress === "billing" && (
                    <div
                      className="envelope-return-addr"
                      style={{ top: "18.0000px", left: "18.0000px" }}
                    >
                      Your billing address will print here.
                    </div>
                  )}

                  {!isSendToMe && (
                    <div
                      className={`envelope-recipient-addr parse-new-lines ${
                        currentPreviewState.FocusedField ===
                        "envelope-recipient"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ top: "232px", left: "250px" }}
                    >
                      {currentPreviewState.EnvelopeRecipientAddress}
                    </div>
                  )}

                  {isSendToMe && (
                    <img
                      src="/dist/images/envelope-watermark-folders.png?v=1.0"
                      className="envelope-watermark"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Draggable>
      </div>
    </div>
  );
}

export default CardPreview;
